import heFlag from '@/modules/i18n/assets/flags/he-flag.svg?url';
import originalConfig from '@base-impl/modules/config/constants/defaultConfig';
import type { KnownConfig } from '@base-impl/modules/config/types/known-config';
import { set, unset } from 'lodash-es';
import type { PartialDeep } from 'type-fest';

const defaultConfig: PartialDeep<KnownConfig> = originalConfig;

set(defaultConfig, 'app.name.__default__', 'Kislev <wbr/>Tires');
unset(defaultConfig, 'i18n.languages.de');
set(defaultConfig, 'i18n.languages.he', {
  code: 'he',
  fullDisplayName: 'Hebrew',
  nativeDisplayName: 'עברית',
  shortDisplayName: 'He',
  dir: 'rtl',
  flagUrl: heFlag,
});
// disable recipient setting and import export settings for branches that start with 'stage' or 'main'
set(defaultConfig, 'features.emailRecipientsSetting.enabled', !['stage', 'main'].some(env => import.meta.env.REACT_APP_BRANCH.startsWith(env)));
set(defaultConfig, 'features.importExportSettings.enabled', !['stage', 'main'].some(env => import.meta.env.REACT_APP_BRANCH.startsWith(env)));
set(defaultConfig, 'features.auth.enableTokenRefreshing', true);
set(defaultConfig, 'features.promotions.erpCodeValidation.enabled', true);
export default defaultConfig;
